<template>
  <div class="nav-wrap">
    <ul class="nav-ul clear">
      <li
        :class="['nav-li' , 'fl' , activeFM.funcname == item.funcname ? 'firstnav-active':'']"
        v-for="(item,index) in initmenulist"
        v-if="item.functype == 'menu'"
        :key="index"
      >
        <div v-if="item.menutype == 'none'">
          <div class="nav-title">
            <i :class="item.clsname"></i>
            <p style="height: 0;width: 80px;">
              {{item.funcname}}
              <img
                style="width: 7px;height: 7px;line-height: 30px;"
                src="../../../static/images/head/白色小三角.png"
              />
            </p>
          </div>
          <div class="nav-down" v-show="item.clsname">
            <ul>
              <li
                v-for="(item2,index2) in initmenulist"
                v-if="item2.pid == item.id"
                :key="index2"
                @click="menuHandler($event,item2)"
              >
                <i class="el-icon-caret-right"></i>
                {{item2.funcname}}
              </li>
            </ul>
          </div>
        </div>
        <div v-else class="nav-title" @click="menuHandler($event,item)">
          <i :class="item.clsname"></i>
          <p>{{item.funcname}}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { queryMenubyroleid, getRolepagebypid } from "@/apis/api";
import { mapState, mapMutations } from "vuex";
export default {
  props: ["userInFo"],
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1-1",
      headmenulist: [],
      initmenulist: [],
      leftmenulist: [],
      activeFM: {},
      roleid: ""
    };
  },
  methods: {
    ...mapMutations([
      "CHANGESECONDMENU",
      "CHANGESECONDMODULE",
      "CHANGESYSMENULIST",
      "CHANGENOWOPTBRESOURCEID"
    ]),
    //获取菜单
    getheadMenu() {
      queryMenubyroleid({ roleid: this.roleid })
        .then(res => {
          if (res.code == "1") {
            //              	console.log(1)
            Object.assign(this.headmenulist, res.result);
            //                  sessionStorage.setItem('key',JSON.stringify(res.result));
            this.initmenulist = res.result;
            //                  console.log(this.initmenulist,12222222)
            this.CHANGESYSMENULIST(res.result);
            this.headmenulist = this.transformTozTreeFormat(
              { idKey: "id", pIdKey: "pid", children: "children" },
              this.headmenulist
            );
            //              	console.log(this.headmenulist)
          } else {
            //                  this.$message({
            //                      message: res.result || '服务请求失败！',
            //                      type: 'warning'
            //                  });
          }
        })
        .catch(err => {
          //              console.log(err)
          this.$message({
            message: "服务请求失败！",
            type: "warning"
          });
        });
    },
    //将列表转化成嵌套式数据
    transformTozTreeFormat(setting, sNodes) {
      var i,
        l,
        key = setting.idKey,
        parentKey = setting.pIdKey,
        childKey = setting.children;
      if (!key || key == "" || !sNodes) return [];

      if (Object.prototype.toString.apply(sNodes) === "[object Array]") {
        var r = [];
        var tmpMap = [];
        for (i = 0, l = sNodes.length; i < l; i++) {
          tmpMap[sNodes[i][key]] = sNodes[i];
        }
        for (i = 0, l = sNodes.length; i < l; i++) {
          if (
            tmpMap[sNodes[i][parentKey]] &&
            sNodes[i][key] != sNodes[i][parentKey]
          ) {
            if (!tmpMap[sNodes[i][parentKey]][childKey])
              tmpMap[sNodes[i][parentKey]][childKey] = [];
            tmpMap[sNodes[i][parentKey]][childKey].push(sNodes[i]);
          } else {
            r.push(sNodes[i]);
          }
        }
        return r;
      } else {
        return [sNodes];
      }
    },
    menuHandler(e, data) {
      $(".nav-ul").children("li").removeClass("firstnav-active");
      sessionStorage.setItem("clickIndex", '');
        // console.log( e,data ,'da')
      let index = JSON.parse(sessionStorage.getItem("i"));
      $(".nav-ul")
        .children("li")
        .eq(index)
        .removeClass("firstnav-active");
      //      	console.log(e,data,888555)
      sessionStorage.setItem("keys", JSON.stringify(e));
      sessionStorage.setItem("keyed", JSON.stringify(data));
      //          console.log(data,2141242);
      //控制菜单高亮
      if (data.functype == "menu") {
        this.activeFM = data;
      } else if (data.functype == "submenu") {
        for (var i = 0, ilen = this.sysMenulist.length; i < ilen; i++) {
          if (data.pid == this.sysMenulist[i].id) {
            this.activeFM = this.sysMenulist[i];
            break;
          }
        }
        $(e.target)
          .closest(".nav-li")
          .find(".nav-down li")
          .removeClass("subactive");

        //              $('.nav-ul').children("li").eq(i).removeClass('firstnav-active')
        $(e.target)
          .closest("li")
          .addClass("subactive");
        $(e.target)
          .closest("li")
          .siblings("li")
          .removeClass("subactive");
      }
      //控制菜单路由跳转
      //          console.log(data,122344)
      if (data.menutype == "custom") {
        if (data.funcname == "首页") {
          sessionStorage.setItem("keys", "{}"); //一级菜单index
          sessionStorage.setItem("keyed", "{}"); //一级菜单数据
          $(".right-menu>li")
            .eq(0)
            .children("p")
            .addClass("secondnav-active")
            .children("img")
            .attr("src", "../../../static/images/head/图层图标-白色.png");
          sessionStorage.setItem("indeX", 0); //二级菜单index
          sessionStorage.setItem("data1", "{}"); //二级菜单数据
          this.$router.push({
            path: "/main/no/home",
            name: "home",
            params: { menudata: this.userInFo.regioncode }
          });
        } else if (data.funcname == "测试子菜单2") {
          this.$router.push({
            path: "/main/no/home",
            name: "home",
            params: { menudata: JSON.stringify(data) }
          });
        } else if (data.funcname == "数据字典") {
          this.$router.push({
            path: "/main/no/datadictionary",
            name: "datadictionary",
            params: { menudata: JSON.stringify(data) }
          });
        } else if (data.funcname == "角色权限") {
          this.$router.push({
            path: "/main/no/roleauthorization",
            name: "roleauthorization",
            params: { menudata: JSON.stringify(data) }
          });
        } else if (data.funcname == "站点权限") {
          this.$router.push({
            path: "/main/no/userprivileges",
            name: "userprivileges",
            params: { menudata: JSON.stringify(data) }
          });
        } else if (data.funcname == "通知管理") {
          this.$router.push({
            path: "/main/no/noticemanage",
            name: "noticemanage",
            params: { menudata: JSON.stringify(data) }
          });
        } else if (data.funcname == "菜单管理") {
          this.$router.push({
            path: "/main/no/menumanage",
            name: "menumanage",
            params: { menudata: JSON.stringify(data) }
          });
        } else if (data.funcname == "巡查详情") {
          this.$router.push({
            path: "/main/have/patroldetail",
            name: "patroldetail",
            params: { menudata: JSON.stringify(data) }
          });
        } else if (data.funcname == "灌区简介") {
          this.$router.push({
            path: "/main/have/guanqujianjie",
            name: "guanqujianjie",
            params: { menudata: this.userInfo.regioncode }
          });
        } else {
          this.$router.push({ path: "/main/have/error404", name: "404" });
        }
      } else if (data.menutype == "listmodule") {
        this.leftmenulist = [];
        for (var i = 0, ilen = this.initmenulist.length; i < ilen; i++) {
          if (data.id == this.initmenulist[i].pid) {
            this.leftmenulist.push(this.initmenulist[i]);
          }
        }

        //              sessionStorage.setItem('keys1',JSON.stringify(this.initmenulist))
        sessionStorage.setItem("keyed1", JSON.stringify(this.leftmenulist));
        //secondMenulist
        //用来控制列表模式的第一个菜单选中
        this.$bus.$emit("trans", this.leftmenulist[0]);
        //              console.log(this.leftmenulist[0],333)
        this.CHANGENOWOPTBRESOURCEID(this.leftmenulist[0].resourceid);
        this.CHANGESECONDMENU(this.leftmenulist);
        this.CHANGESECONDMODULE(this.leftmenulist[0]);
        sessionStorage.setItem("keys1", JSON.stringify(this.initmenulist));
        $(".right-menu>li")
          .eq(0)
          .children("p")
          .addClass("secondnav-active")
          .children("img")
          .attr("src", "../../../static/images/head/图层图标-白色.png");
        $(".right-menu>li")
          .eq(0)
          .siblings("li")
          .children("p")
          .removeClass("secondnav-active")
          .children("img")
          .attr("src", "../../../static/images/head/图层图标-深色.png");
        if (this.leftmenulist[0].funcname == "简介") {
          this.$router.push({
            path: "main/have/guanqujianjie",
            name: "guanqujianjie",
            params: { menudata: this.userInFo.regioncode }
          });
        } else if (this.leftmenulist[0].funcname == "基本情况介绍") {
          this.$router.push({
            path: "/main/have/formlist",
            name: "formlist",
            params: { menudata: JSON.stringify(data) }
          });
        } else if (this.leftmenulist[0].funcname == "巡查记录管理") {
          this.$router.push({
            path: "/main/have/formlist",
            name: "formlist",
            params: { menudata: JSON.stringify(data) }
          });
        } else if (this.leftmenulist[0].funcname == "测点信息管理") {
          this.$router.push({
            path: "/main/have/stationmanagement",
            name: "stationmanagement",
            params: { menudata: this.userInFo.regioncode }
          });
        } else if (this.leftmenulist[0].funcname == "测流计算") {
          this.$router.push({
            path: "/main/have/fittingdischarge",
            name: "fittingdischarge",
            params: { menudata: this.userInFo.regioncode }
          });
        } else if (this.leftmenulist[0].funcname == "实测流量成果表") {
          this.$router.push({
            path: "/main/have/resultsOfMeasuredDischarge",
            name: "resultsOfMeasuredDischarge",
            params: { menudata: this.userInFo.regioncode }
          });
        } else if (this.leftmenulist[0].funcname == "实时配出合成报表") {
          this.$router.push({
            path: "/main/have/realtimematchingreport",
            name: "realtimematchingreport",
            params: { menudata: this.userInFo.regioncode }
          });
        } else if (this.leftmenulist[0].funcname == "逐日流量初整表") {
          this.$router.push({
            path: "/main/have/dailyaverageflowmeterchuzheng",
            name: "dailyaverageflowmeterchuzheng",
            params: { menudata: this.userInFo.regioncode }
          });
        } else if (this.leftmenulist[0].funcname == "逐日流量整编表") {
          this.$router.push({
            path: "/main/have/dailyaverageflowmeter",
            name: "dailyaverageflowmeter",
            params: { menudata: this.userInFo.regioncode }
          });
        } else if (this.leftmenulist[0].funcname == "逐日平均水量表") {
          this.$router.push({
            path: "/main/have/dailyaveragewatervolume",
            name: "dailyaveragewatervolume",
            params: { menudata: this.userInFo.regioncode }
          });
        } else if (this.leftmenulist[0].funcname == "水位流量过程线") {
          this.$router.push({
            path: "/main/have/shuiweiliuliangguochengxian",
            name: "shuiweiliuliangguochengxian",
            params: { menudata: this.userInFo.regioncode }
          });
        } else if (this.leftmenulist[0].funcname == "实时水情信息") {
          this.$router.push({
            path: "/main/have/shishishuiqingxinxi",
            name: "shishishuiqingxinxi",
            params: { menudata: this.userInFo.regioncode }
          });
        } else if (this.leftmenulist[0].funcname == "巡查详情") {
          this.$router.push({
            path: "/main/have/patroldetail",
            name: "patroldetail",
            params: { menudata: this.userInFo.regioncode }
          });
        } else if (this.leftmenulist[0].funcname == "单价管理") {
          // 防止 URL 自动跳转
          // if(!this.$route.matched.some(item => item.name === 'waterfee-pricing')){
          this.$router.push({
            path: "/main/have/waterfee-pricing/period-search"
          });
          // }
        } else {
          this.$router.push({ path: "/main/have/error404", name: "404" });
        }
      }
    }
  },
  created() {

  },
  mounted() {
       var data = JSON.parse(sessionStorage.getItem("keyed"));
    this.roleid = this.userInfo.roleid;
    //  	console.log(this.$route.params.menudata,'userInFo')
    this.getheadMenu();
    var e = JSON.parse(sessionStorage.getItem("keys"));
    this.initmenulist = JSON.parse(sessionStorage.getItem("keys1"));
    this.leftmenulist = JSON.parse(sessionStorage.getItem("keyed1"));
    //      console.log(e,data,999666)
    let Index= sessionStorage.getItem("clickIndex");
    let index= sessionStorage.getItem("leftIndex");

    $(".nav-ul").on("mouseenter", ".nav-li", function(e) {
      e.preventDefault();
      var $this = $(this);
      if ($this.hasClass("first-down")) {
        $this.removeClass("first-down");
        $this
          .closest("li")
          .find(".nav-down")
          .stop()
          .fadeOut(0);
      } else {
        $this.addClass("first-down");
        $this
          .closest("li")
          .find(".nav-down")
          .stop()
          .fadeIn(0);
      }
    });
    $(".nav-ul").on("mouseleave", ".nav-li", function() {
      var $this = $(this);
      $this.removeClass("first-down");
      $this
        .closest("li")
        .find(".nav-down")
        .stop()
        .fadeOut(0);
    });
    if (data) {
    if(Index){
        console.log(Index,index,$(".nav-ul"))
         this.$bus.$emit("trans", this.leftmenulist[Number(index)]);
        this.CHANGENOWOPTBRESOURCEID(this.leftmenulist[Number(index)].resourceid);
        this.CHANGESECONDMENU(this.leftmenulist);
        this.CHANGESECONDMODULE(this.leftmenulist[Number(index)]);
        setTimeout(()=>{
        $(".nav-ul")
        .children("li")
        .removeClass("firstnav-active");
        $(".nav-ul")
        .children("li")
        .eq(Number(Index))
        .addClass("firstnav-active");
        },1000)
    }else{
           this.menuHandler(e, data);
    }

    }
  },
  computed: {
    ...mapState(["userInfo", "sysMenu", "sysMenulist", "nowSelectModule"])
  },
  beforeDestroy() {
    this.$bus.$off("trans");
  },
  watch: {

    $route(to, from) {
        if(to.name=='wateralarm'){
           this.initmenulist.forEach((item,Index)=>{
               if(item.funcname== "水雨情信息"){
                   let index=0
        sessionStorage.setItem("keyed", JSON.stringify(item));
                   this.leftmenulist=item.children
                   this.leftmenulist.forEach((items,i)=>{
                       if(items.funcname== "水位报警"){
                           index=i
                       }
                   })
                   $(".nav-ul")
        .children("li")
        .removeClass("firstnav-active");
        $(".nav-ul")
        .children("li")
        .eq(Index-1)
        .addClass("firstnav-active");
                   sessionStorage.setItem("keyed1", JSON.stringify(this.leftmenulist));
                   sessionStorage.setItem("clickIndex", JSON.stringify(Index-1));
                   sessionStorage.setItem("leftIndex", JSON.stringify(index));
        //secondMenulist
        //用来控制列表模式的第一个菜单选中
        this.$bus.$emit("trans", this.leftmenulist[index]);
        //              console.log(this.leftmenulist[0],333)
        this.CHANGENOWOPTBRESOURCEID(this.leftmenulist[index].resourceid);
        this.CHANGESECONDMENU(this.leftmenulist);
        this.CHANGESECONDMODULE(this.leftmenulist[index]);
        sessionStorage.setItem("keys1", JSON.stringify(this.initmenulist));
           console.log(this.initmenulist,'this.initmenulist')
               }
           })

        }
    }
    //      nowSelectModule:{
    //          handler:function(val,oldval){
    //                  for(var i = 0 , ilen = this.sysMenulist.length ; i < ilen ; i++) {
    //                      if(val.pid == this.sysMenulist[i].id) {
    //                          this.activeFM = this.sysMenulist[i];
    //                          break;
    //                      }
    //                  }
    //              },
    //              deep:true
    //      }
  }
};
</script>

<style lang="less">
.nav-wrap {
  // height: 60px;
  // background-color: #4682B4;
  .nav-ul {
    margin-left: 25px;
    .nav-li {
      position: relative;
      padding: 0 3px;
      height: 70px;
      cursor: pointer;
      font-size: 15px;
      &:hover .nav-title {
        background-color: #306ac4;
        color: white;
      }
      .nav-title {
        height: 75px;
        position: relative;
        line-height: 30px;
        text-align: center;
        padding: 0 2px;
        color: #fff;

        i {
          display: inline-block;
          margin-top: 7px;
          font-size: 30px;
        }

        .icon-nav-shouye {
          /* icon-nav-home*/
          width: 40px;
          height: 40px;
          background: url("../../../static/images/head/首页.png");
          background-repeat: no-repeat;
          background-size: cover;
        }
        .icon-nav-guanquxinxi {
          /*icon-nav-dataMag*/
          width: 40px;
          height: 40px;
          background: url("../../../static/images/head/灌区信息.png");
          background-repeat: no-repeat;
          background-size: cover;
        }
        .icon-nav-liangceshui {
          /* icon-nav-monitor*/
          width: 40px;
          height: 40px;
          background: url("../../../static/images/head/量测水管理.png");
          background-repeat: no-repeat;
          background-size: cover;
        }
        .icon-nav-sfjs {
          /*icon-nav-law*/
          width: 40px;
          height: 40px;
          background: url("../../../static/images/head/水费计收.png");
          background-repeat: no-repeat;
          background-size: cover;
        }
        .icon-zt-shuiyuqing {
          /*icon-zt-wasteoil*/
          width: 40px;
          height: 40px;
          background: url("../../../static/images/head/水雨情信息.png");
          background-repeat: no-repeat;
          background-size: cover;
        }
        .icon-nav-tongji {
          /*icon-nav-dataCount*/
          width: 40px;
          height: 40px;
          background: url("../../../static/images/head/统计查询.png");
          background-repeat: no-repeat;
          background-size: cover;
        }
        .icon-map-xuncha {
          /* icon-map-xzqh*/
          width: 40px;
          height: 40px;
          background: url("../../../static/images/head/巡查管理.png");
          background-repeat: no-repeat;
          background-size: cover;
        }
        .icon-nav-yunwei {
          /*icon-nav-operate*/
          width: 39px;
          height: 39px;
          background: url("../../../static/images/head/运维管理.png");
          background-repeat: no-repeat;
          background-size: cover;
        }
        .icon-nav-dinzhi {
          /*  icon-nav-law*/
          width: 40px;
          height: 40px;
          background: url("../../../static/images/head/定制报表.png");
          background-repeat: no-repeat;
          background-size: cover;
        }

        p {
          line-height: 0px;
        }
      }
      .nav-down {
        display: none;
        position: absolute;
        top: 70px;
        z-index: 30100;
        width: 130px;
        padding-top: 2px;
        ul {
          background-color: #fff;
          border-radius: 5px;
          /*z-index: 3000000;*/
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border: 1px solid #e3e3e3;
          li {
            height: 30px;
            line-height: 30px;
            text-align: center;
            &:hover,
            &.subactive {
              background-color: #306ac4;
              color: #fff;
            }
          }
        }
      }
    }
  }
}
.firstnav-active {
  .nav-title {
    // color: red!important;
    background: #306ac4;
    i {
      color: #fff;
      line-height: 0px;
    }
    p {
      color: #fff;
      line-height: 0px;
    }
  }
}
.navli-active {
  li {
    background-color: #4682b4;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mainInterface/nav-head.vue